import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alertSuccess",
  "use": "alertSuccess-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"alertSuccess\">\n<path d=\"M9 17.25C13.5563 17.25 17.25 13.5563 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 13.5563 4.44365 17.25 9 17.25ZM8.29237 12.353L5.46968 9.53026L6.53034 8.4696L8.20765 10.1469L12.1806 5.51184L13.3195 6.48803L8.29237 12.353Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol